// Date-input values ("YYYY-MM-DD") and the timestamps sent to the API.
//
// toISOString() is UTC, so Date -> input value through it gave the day before
// in Israel between midnight and 02:00/03:00: "1 Year" chosen at 01:30 set
// 364 days, and opening a license renewed at that hour showed - and on any
// save wrote back - the previous day.

export const toDateInputValue = (date: Date): string => {
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${date.getFullYear()}-${month}-${day}`;
};

// A license set to expire on the 30th is valid through the 30th. Sent as a
// bare "YYYY-MM-DD" the server parsed it as UTC midnight, which is 02:00 or
// 03:00 on the 30th in Israel - the license died on the morning of its last day.
export const toExpirationTimestamp = (dateInputValue: string): string => {
	const [year, month, day] = dateInputValue.split("-").map(Number);
	return new Date(year, month - 1, day, 23, 59, 59, 999).toISOString();
};

// What an edit form sends for the expiration date. Only a day the user
// changed becomes a new timestamp; sending the form's day back on every save
// moved the stored time of day - and, before the UTC fix, the day itself -
// on edits that never touched the date.
export const toSubmittedExpiration = (
	dateInputValue: string,
	originalTimestamp?: string,
): string => {
	if (originalTimestamp && toDateInputValue(new Date(originalTimestamp)) === dateInputValue) {
		return originalTimestamp;
	}
	return toExpirationTimestamp(dateInputValue);
};
